/* istanbul ignore file */
/* tslint:disable */
 
import type { AccidentContractDetail } from '../models/AccidentContractDetail';
import type { BasePropertyContractDetail } from '../models/BasePropertyContractDetail';
import type { CascoContractDetail } from '../models/CascoContractDetail';
import type { ClientStatisticsOutput } from '../models/ClientStatisticsOutput';
import type { ConversionStatisticsOutput } from '../models/ConversionStatisticsOutput';
import type { MedicalContractDetail } from '../models/MedicalContractDetail';
import type { PaginatedAccidentContractListList } from '../models/PaginatedAccidentContractListList';
import type { PaginatedBasePropertyContractList } from '../models/PaginatedBasePropertyContractList';
import type { PaginatedCascoContractListList } from '../models/PaginatedCascoContractListList';
import type { PaginatedMedicalContractListList } from '../models/PaginatedMedicalContractListList';
import type { ProductEvolutionStatisticsOutput } from '../models/ProductEvolutionStatisticsOutput';
import type { SalesStatisticsOutput } from '../models/SalesStatisticsOutput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AnalyticsService {

  /**
   * ViewSet for accident insurance contract registry.
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus Status contract: Activ / Expirat / Reziliat / În așteptare plată
 *
 * * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param ordering Which field to use when ordering the results.
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search A search term.
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns PaginatedAccidentContractListList 
   * @throws ApiError
   */
  public static analyticsRegistersAccidentsList(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
ordering?: string,
page?: number,
pageSize?: number,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<PaginatedAccidentContractListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/accidents/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * ViewSet for accident insurance contract registry.
   * @param id A unique integer value identifying this order.
   * @returns AccidentContractDetail 
   * @throws ApiError
   */
  public static analyticsRegistersAccidentsRetrieve(
id: number,
): CancelablePromise<AccidentContractDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/accidents/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * ViewSet for accident insurance contract registry.
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus Status contract: Activ / Expirat / Reziliat / În așteptare plată
 *
 * * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param ordering Which field to use when ordering the results.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search A search term.
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns binary 
   * @throws ApiError
   */
  public static analyticsRegistersAccidentsXlsxRetrieve(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
ordering?: string,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/accidents/xlsx/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'ordering': ordering,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param number 
   * @param ordering Ordering fields: policy__date, status, number
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search Search fields: parent__policy__number, policy__number, contractor__as_person__first_name, contractor__as_person__last_name, contractor__as_person__identification_number, contractor__as_legalentity__name, contractor__as_legalentity__identification_number
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns PaginatedCascoContractListList 
   * @throws ApiError
   */
  public static analyticsRegistersCascoList(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
number?: string,
ordering?: string,
page?: number,
pageSize?: number,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<PaginatedCascoContractListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/casco/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'number': number,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this order.
   * @returns CascoContractDetail 
   * @throws ApiError
   */
  public static analyticsRegistersCascoRetrieve(
id: number,
): CancelablePromise<CascoContractDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/casco/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param number 
   * @param ordering Ordering fields: policy__date, status, number
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search Search fields: parent__policy__number, policy__number, contractor__as_person__first_name, contractor__as_person__last_name, contractor__as_person__identification_number, contractor__as_legalentity__name, contractor__as_legalentity__identification_number
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns binary 
   * @throws ApiError
   */
  public static analyticsRegistersCascoXlsxRetrieve(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
number?: string,
ordering?: string,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/casco/xlsx/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'number': number,
        'ordering': ordering,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * ViewSet for medical insurance contract registry.
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus Status contract: Activ / Expirat / Reziliat / În așteptare plată
 *
 * * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param ordering Which field to use when ordering the results.
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search A search term.
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns PaginatedMedicalContractListList 
   * @throws ApiError
   */
  public static analyticsRegistersMedicalList(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
ordering?: string,
page?: number,
pageSize?: number,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<PaginatedMedicalContractListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/medical/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * ViewSet for medical insurance contract registry.
   * @param id A unique integer value identifying this order.
   * @returns MedicalContractDetail 
   * @throws ApiError
   */
  public static analyticsRegistersMedicalRetrieve(
id: number,
): CancelablePromise<MedicalContractDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/medical/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Custom Excel export with formatted headers, merged cells, and totals row
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus Status contract: Activ / Expirat / Reziliat / În așteptare plată
 *
 * * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param ordering Which field to use when ordering the results.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search A search term.
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns binary 
   * @throws ApiError
   */
  public static analyticsRegistersMedicalXlsxRetrieve(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
ordering?: string,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/medical/xlsx/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'ordering': ordering,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param number 
   * @param ordering Ordering fields: policy__date, status, number
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search Search fields: parent__policy__number, policy__number, contractor__as_person__first_name, contractor__as_person__last_name, contractor__as_person__identification_number, contractor__as_legalentity__name, contractor__as_legalentity__identification_number
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns PaginatedBasePropertyContractList 
   * @throws ApiError
   */
  public static analyticsRegistersPropertyList(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
number?: string,
ordering?: string,
page?: number,
pageSize?: number,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<PaginatedBasePropertyContractList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/property/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'number': number,
        'ordering': ordering,
        'page': page,
        'page_size': pageSize,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * @param id A unique integer value identifying this order.
   * @returns BasePropertyContractDetail 
   * @throws ApiError
   */
  public static analyticsRegistersPropertyRetrieve(
id: number,
): CancelablePromise<BasePropertyContractDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/property/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param agent Filtrează comenzile după ID-urile agenților.
   * @param amountGte Filtrează comenzile cu suma mai mare sau egală decât valoarea transmisă.
   * @param amountLte Filtrează comenzile cu suma mai mică sau egală decât valoarea transmisă.
   * @param author 
   * @param broker 
   * @param contractStatus * `pending` - Pending
 * * `active` - Active
 * * `revised` - Revised
 * * `canceled` - Canceled
 * * `terminated` - Terminated
 * * `expired` - Expired
   * @param contractType Filtrează comenzile de accidente după tipul contractului.
 *
 * * `individual` - Individual
 * * `familial` - Familial
 * * `collective` - Collective
   * @param contractor 
   * @param contractorType Filtrează comenzile după tipul contractantului: persoană fizică sau entitate juridică.
 *
 * * `person` - Person
 * * `legalentity` - Legal Entity
   * @param customer 
   * @param customerIsNull 
   * @param dateGte 
   * @param dateLte 
   * @param excludeIds comma separated list
   * @param excludeStatus Exclude comenzile care au oricare dintre statusurile transmise.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param ids comma separated list
   * @param insured Filtrează comenzile după ID-urile entităților asigurate.
   * @param isModified Filtrează comenzile în funcție de existența unor comenzi de modificare ulterioare.
   * @param isRegisteredUser Filtrează comenzile create pentru utilizatori înregistrați sau pentru clienți anonimi.
   * @param number 
   * @param ordering Ordering fields: policy__date, status, number
   * @param paymentType Filtrează comenzile după tipul de plată al facturii.
 *
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
   * @param policyNumber Filtrează comenzile după numărul poliței, potrivire parțială.
   * @param product 
   * @param productCode Filtrează comenzile după codul exact al produsului.
   * @param search Search fields: parent__policy__number, policy__number, contractor__as_person__first_name, contractor__as_person__last_name, contractor__as_person__identification_number, contractor__as_legalentity__name, contractor__as_legalentity__identification_number
   * @param source Filtrează comenzile după sursa din care au fost create.
 *
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
   * @param status Filtrează comenzile după status.
 *
 * * `draft` - Draft
 * * `checkout` - Checkout
 * * `in_progress` - In Progress
 * * `paid` - Paid
 * * `partial_paid` - Partial Paid
 * * `error` - Error
 * * `critical` - Critical
 * * `canceled` - Canceled
 * * `completed` - Completed
 * * `expired` - Expired
 * * `pending_refund` - Pending Refund
 * * `pending` - Pending
 * * `refunded` - Refunded
 * * `overdue` - Overdue
 * * `terminated` - Terminated
 * * `refused` - Refused
 * * `submitted` - Submitted
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `in_processing` - In Processing
   * @param team SAAS id
   * @param type Filtrează comenzile după tipul comenzii.
 *
 * * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param user 
   * @param validFromGte Filtrează comenzile cu data de început a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToGte Filtrează comenzile cu data de sfârșit a valabilității mai mare sau egală decât valoarea transmisă.
   * @param validToLte Filtrează comenzile cu data de sfârșit a valabilității mai mică sau egală decât valoarea transmisă.
   * @returns binary 
   * @throws ApiError
   */
  public static analyticsRegistersPropertyXlsxRetrieve(
agent?: Array<number>,
amountGte?: number,
amountLte?: number,
author?: number,
broker?: number,
contractStatus?: 'active' | 'canceled' | 'expired' | 'pending' | 'revised' | 'terminated',
contractType?: 'collective' | 'familial' | 'individual',
contractor?: number,
contractorType?: 'legalentity' | 'person',
customer?: number,
customerIsNull?: boolean,
dateGte?: string,
dateLte?: string,
excludeIds?: string,
excludeStatus?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
ids?: string,
insured?: Array<number>,
isModified?: boolean,
isRegisteredUser?: boolean,
number?: string,
ordering?: string,
paymentType?: Array<'bank_transfer' | 'broker_settlement' | 'card' | 'cash' | 'cash_mia' | 'credit' | 'manual' | 'mia' | 'pos'>,
policyNumber?: string,
product?: number,
productCode?: string,
search?: string,
source?: Array<'agent' | 'broker' | 'website'>,
status?: Array<'approved' | 'canceled' | 'checkout' | 'completed' | 'critical' | 'data_entry' | 'draft' | 'error' | 'expired' | 'in_processing' | 'in_progress' | 'inspection' | 'offer_ready' | 'overdue' | 'paid' | 'partial_paid' | 'pending' | 'pending_refund' | 'refunded' | 'refused' | 'rejected' | 'submitted' | 'terminated'>,
team?: string,
type?: Array<'cancel' | 'modification' | 'order'>,
user?: number,
validFromGte?: string,
validToGte?: string,
validToLte?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/registers/property/xlsx/',
      query: {
        'agent': agent,
        'amount_gte': amountGte,
        'amount_lte': amountLte,
        'author': author,
        'broker': broker,
        'contract_status': contractStatus,
        'contract_type': contractType,
        'contractor': contractor,
        'contractor_type': contractorType,
        'customer': customer,
        'customer_is_null': customerIsNull,
        'date_gte': dateGte,
        'date_lte': dateLte,
        'exclude_ids': excludeIds,
        'exclude_status': excludeStatus,
        'ids': ids,
        'insured': insured,
        'is_modified': isModified,
        'is_registered_user': isRegisteredUser,
        'number': number,
        'ordering': ordering,
        'payment_type': paymentType,
        'policy_number': policyNumber,
        'product': product,
        'product_code': productCode,
        'search': search,
        'source': source,
        'status': status,
        'team': team,
        'type': type,
        'user': user,
        'valid_from_gte': validFromGte,
        'valid_to_gte': validToGte,
        'valid_to_lte': validToLte,
      },
    });
  }

  /**
   * Retrieve client_statistics report
   * Generates and returns the client_statistics report.
   * @param endDate 
   * @param startDate 
   * @param product Filter by specific insurance product (automatically filtered by your permissions)
 *
 * * `rca` - RCA
 * * `green_card` - Carte Verde
 * * `medical_travel` - Asigurarea medicală
 * * `accidents` - Asigurarea de accidente
 * * `casco` - Casco
 * * `property` - Asigurarea bunurilor
 * * `cmr` - Asigurarea CMR
   * @param source Filter by order source (website, agent, broker)
   * @returns ClientStatisticsOutput 
   * @throws ApiError
   */
  public static analyticsStatisticsClientStatisticsRetrieve(
endDate: string,
startDate: string,
product?: 'rca' | 'green_card' | 'medical_travel' | 'accidents' | 'casco' | 'property' | 'cmr',
source?: Array<'website' | 'agent' | 'broker'>,
): CancelablePromise<ClientStatisticsOutput> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/statistics/client_statistics/',
      query: {
        'end_date': endDate,
        'product': product,
        'source': source,
        'start_date': startDate,
      },
    });
  }

  /**
   * Retrieve conversion_statistics report
   * Generates and returns the conversion_statistics report.
   * @param endDate 
   * @param product Filter by specific insurance product
 *
 * * `rca` - RCA
 * * `green_card` - Carte Verde
 * * `medical_travel` - Asigurarea medicală
 * * `accidents` - Asigurarea de accidente
 * * `casco` - Casco
 * * `property` - Asigurarea bunurilor
 * * `cmr` - Asigurarea CMR
   * @param startDate 
   * @param source Filter by order source (website, agent, broker)
   * @returns ConversionStatisticsOutput 
   * @throws ApiError
   */
  public static analyticsStatisticsConversionStatisticsRetrieve(
endDate: string,
product: 'rca' | 'green_card' | 'medical_travel' | 'accidents' | 'casco' | 'property' | 'cmr',
startDate: string,
source?: Array<'website' | 'agent' | 'broker'>,
): CancelablePromise<ConversionStatisticsOutput> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/statistics/conversion_statistics/',
      query: {
        'end_date': endDate,
        'product': product,
        'source': source,
        'start_date': startDate,
      },
    });
  }

  /**
   * Retrieve product_evolution report
   * Generates and returns the product_evolution report.
   * @param periodNumber Month (1-12) or Quarter (1-4)
   * @param product Filter by specific insurance product
 *
 * * `rca` - RCA
 * * `green_card` - Carte Verde
 * * `medical_travel` - Asigurarea medicală
 * * `accidents` - Asigurarea de accidente
 * * `casco` - Casco
 * * `property` - Asigurarea bunurilor
 * * `cmr` - Asigurarea CMR
   * @param reportPeriod Report period type: LUNĂ (Month) or TRIMESTRU (Quarter)
 *
 * * `month` - Month
 * * `quarter` - Quarter
   * @param year Year (2020 to current)
   * @param source Filter by order source (website, agent, broker)
   * @returns ProductEvolutionStatisticsOutput 
   * @throws ApiError
   */
  public static analyticsStatisticsProductEvolutionRetrieve(
periodNumber: number,
product: 'rca' | 'green_card' | 'medical_travel' | 'accidents' | 'casco' | 'property' | 'cmr',
reportPeriod: 'month' | 'quarter',
year: number,
source?: Array<'website' | 'agent' | 'broker'>,
): CancelablePromise<ProductEvolutionStatisticsOutput> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/statistics/product_evolution/',
      query: {
        'period_number': periodNumber,
        'product': product,
        'report_period': reportPeriod,
        'source': source,
        'year': year,
      },
    });
  }

  /**
   * Retrieve sales_statistics report
   * Generates and returns the sales_statistics report.
   * @param endDate 
   * @param startDate 
   * @param product Filter by specific insurance product (automatically filtered by your permissions)
 *
 * * `rca` - RCA
 * * `green_card` - Carte Verde
 * * `medical_travel` - Asigurarea medicală
 * * `accidents` - Asigurarea de accidente
 * * `casco` - Casco
 * * `property` - Asigurarea bunurilor
 * * `cmr` - Asigurarea CMR
   * @param source Filter by order source (website, agent, broker)
   * @returns SalesStatisticsOutput 
   * @throws ApiError
   */
  public static analyticsStatisticsSalesStatisticsRetrieve(
endDate: string,
startDate: string,
product?: 'rca' | 'green_card' | 'medical_travel' | 'accidents' | 'casco' | 'property' | 'cmr',
source?: Array<'website' | 'agent' | 'broker'>,
): CancelablePromise<SalesStatisticsOutput> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/analytics/statistics/sales_statistics/',
      query: {
        'end_date': endDate,
        'product': product,
        'source': source,
        'start_date': startDate,
      },
    });
  }

}
